import { almostZero, Currency as GenericCurrency, isZeroDecimal, numberFormat } from "@xola/ui-kit";
import { getUserLocale } from "get-user-locale";
import React, { ReactNode } from "react";
import { useSeller } from "../../hooks/useAccount";
import { useLocalizationStore } from "@/stores/localizationStore";

// I don't like the long property names. We need better names
interface CurrencyProps {
    /** Remove trailing zeros like ".00" from the end of amount so $100.00 is shown as $100 */
    shouldRemoveTrailingZeroes?: boolean;
    compact?: boolean;
    /** Maximum decimal values to show. Defaults to 2 $100.234 is shown as $100.23 */
    maximumFractionDigits?: number;
    currency?: string;
    locale?: string;
    children: ReactNode;
}

export const Currency = ({
    shouldRemoveTrailingZeroes = true,
    maximumFractionDigits = 2,
    compact = false,
    locale,
    currency,
    ...rest
}: CurrencyProps) => {
    const seller = useSeller();
    const userLocale = useLocalizationStore().getLocale();

    return (
        <GenericCurrency
            currency={currency ?? seller.currency}
            shouldRemoveTrailingZeroes={shouldRemoveTrailingZeroes}
            maximumFractionDigits={maximumFractionDigits}
            compact={compact}
            locale={locale ?? userLocale}
            {...rest}
        />
    );
};

Currency.Round = (props: any) => <GenericCurrency.Round {...props} />;
Currency.Split = (props: any) => <GenericCurrency.Split {...props} />;

export const getValueWithCurrency = (amount: number, currency: string, locale?: string) => {
    const userLocale = getUserLocale();

    const amountVariable = almostZero(amount) ? 0 : amount;
    const maxDigits = isZeroDecimal(currency) ? 0 : 2;
    const formattedAmount = numberFormat(amountVariable, currency, locale ?? userLocale, maxDigits, false).replace(
        ".00",
        "",
    );

    return `${formattedAmount}`;
};
